module.exports = __webpack_public_path__ + "media/images/flags/32/French-Southern-Territories-ecc7cf928703eec85b3ab22b39a2f035.png";